import { distributorUser, DistributorUserTypes } from './types';

export const acGetDistributorUser = (payload: distributorUser) => {
  return {
    type: DistributorUserTypes.GET_DISTRIBUTOR_USER,
    payload: payload,
  };
};
